import axiosInstance from './axiosConfig';

const REST_API_BASE_URL = '/coordinators';
// const REST_API_BASE_URL = '/api';

export const getAllCoordinators = () => axiosInstance.get(REST_API_BASE_URL);

export const getCoordinatorById = (id) => axiosInstance.get(`${REST_API_BASE_URL}/${id}`);

export const getCoordinatorByEmail = (email) =>
    axiosInstance.get(`${REST_API_BASE_URL}/email`, { params: { email } });

export const createCoordinator = (coordinator) =>
    axiosInstance.post(REST_API_BASE_URL, coordinator);

export const getTotalCoordinatorCount = () => axiosInstance.get(`${REST_API_BASE_URL}/count`);

export const updateCoordinator = (id, coordinator) =>
    axiosInstance.put(`${REST_API_BASE_URL}/${id}`, coordinator);

export const updateCoordinatorStatus = (id, coordinatorStatus) => {
    return axiosInstance.patch(`${REST_API_BASE_URL}/${id}/status`, null, {
        params: { coordinatorStatus },
    });
};

export const deleteCoordinator = (id) =>
    axiosInstance.delete(`${REST_API_BASE_URL}/${id}`);